import React from 'react';
import { useNavigate } from 'react-router-dom';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-50 min-h-screen py-8 px-4 sm:px-6 lg:px-8 text-gray-800">
      <div className="max-w-4xl mx-auto bg-white p-8 sm:p-12 rounded-xl shadow-sm border border-gray-200">
        {/* Navigation & Header */}
        <div className="flex items-center justify-between border-b pb-6 mb-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-sm font-medium text-blue-600 hover:text-blue-800 transition-colors"
          >
            <svg
              className="w-5 h-5 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Back to Home
          </button>
          <span className="text-xs text-gray-400 uppercase tracking-wider">Legal Terms</span>
        </div>

        <h1 className="text-3xl font-extrabold text-gray-900 mb-2">Terms and Conditions</h1>
        <p className="text-sm text-gray-500 mb-8">Effective Date: October 8, 2026</p>

        <div className="space-y-8 text-sm sm:text-base leading-relaxed text-gray-700">
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">1. Agreement to Terms</h2>
            <p>
              Welcome to Flex Logistics Management ("Company," "we," "us," or "our"). These Terms and Conditions govern your access to and use of our website, freight quote forms, advisory consultations, driver management portals, and shipping logistics services (collectively, "Services"). By accessing our website or engaging our Services, you agree to be bound by these Terms and our Privacy Policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">2. Logistics & Freight Quotes</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Estimates & Rates:</strong> Rate quotes generated online or provided via email are based on current market estimates and information provided by the customer. Quotes are subject to final freight weight, dimensions, equipment availability, and fuel surcharge updates prior to dispatch confirmation.
              </li>
              <li>
                <strong>Bill of Lading (BOL):</strong> A finalized Bill of Lading serves as the primary document governing cargo transit. Customers are responsible for verifying all load weights, hazardous materials designations, and delivery addresses prior to driver collection.
              </li>
              <li>
                <strong>Transit Times:</strong> Estimated delivery timelines are non-guaranteed unless explicitly secured under a binding premium service contract.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">3. Advisory & Consultation Services</h2>
            <p className="mb-3">
              Flex Logistics Management offers logistics planning, supply chain evaluation, and freight optimization consultations.
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Nature of Advice:</strong> Consultations provide strategic guidance based on industry standards and data available at the time of session. They do not constitute guaranteed commercial outcomes or formal legal/financial counsel.
              </li>
              <li>
                <strong>Scheduling & Cancellation:</strong> Consultation sessions must be scheduled in advance. Cancellations or reschedules must be submitted at least 24 hours prior to the scheduled session.
              </li>
              <li>
                <strong>Confidentiality:</strong> Both parties agree to maintain the confidentiality of non-public business strategies, carrier rates, and operational information disclosed during consultations.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">4. Payments & Billing</h2>
            <p>
              Payments for freight transport, consultation fees, and related services are processed securely using electronic payment gateways (e.g., Stripe). Charges must be settled in accordance with the payment terms specified on invoices or booking agreements. Failure to pay on time may result in service suspension or collection proceedings.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">5. User Conduct & Accounts</h2>
            <p>
              When creating an account or submitting inquiries, you agree to provide true, current, and complete information. You are prohibited from using our site to transmit fraudulent shipping documentation, violate Department of Transportation (DOT) or FMCSA safety rules, or engage in unauthorized access to driver or administrative portals.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">6. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by United States law, Flex Logistics Management shall not be liable for indirect, incidental, consequential, or punitive damages resulting from loss of profits, transit delays due to severe weather/road closures, or force majeure events. Cargo liability for loss or damage is governed specifically by applicable Carmack Amendment provisions or designated insurance policies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">7. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the United States and the State in which Flex Logistics Management maintains its primary place of business, without regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">8. Changes to Terms</h2>
            <p>
              We reserve the right to update or modify these Terms at any time. Changes will be posted on this page with an updated effective date. Continued use of our site or services after changes are posted constitutes acceptance of the revised Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">9. Contact Us</h2>
            <p>For questions or formal inquiries regarding these Terms & Conditions, please contact us:</p>
            <div className="mt-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <p className="font-semibold text-gray-900">Flex Logistics Management</p>
              <p className="text-gray-600">Email: flexlogisticsmanagement1@gmail.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;